import * as React from "react";
import {t} from "i18next";
import {connect} from "react-redux";
import {compose} from "redux";
import {Table, Label} from 'semantic-ui-react';
import ColumnFactory from "../../../services/ColumnFactory";
import Dialog from "../../../components/Dialogs/Dialog";
import Button from "../../../components/Button";
import {CnrDto} from "src/services/Client";
import {PSLCopyType} from "./PslSelectionDialog";
import {selectBasicMarketCnr, selectUserCnrs} from "../../../redux/selectors";
import {IReduxState} from "src/redux/IReduxState";

interface IOwnProps {
    pslCopyContexts: PSLCopyType;
    stats: {[key: number]: number};
    onConfirm(): void;
    onCancel(): void;
}

interface IMapStateToProps {
    basicMarketCnr?: CnrDto;
    cnrList?: CnrDto[];
}

interface IPSLCopyStatsDialogProps extends IOwnProps, IMapStateToProps {
}

const PSLCopyStatsDialog: React.StatelessComponent<IPSLCopyStatsDialogProps> = (props: IPSLCopyStatsDialogProps) => {
    let pslCopyParams = {
        sourceModelyear: ColumnFactory.mj2str(props.pslCopyContexts.sourceModelyear),
        sourceTypefamily: props.pslCopyContexts.sourceTypefamily.name
    };
    let totalCount: number = Object.keys(props.stats).length > 0 ?
        Object.keys(props.stats).map((key) => props.stats[key])
            .reduce((a: number, b: number) => {
                return a + b;
            })
        :
        0;
    const specificMarketsKeys = Object.keys(props.stats).filter((key) => props.basicMarketCnr && key !== props.basicMarketCnr.objectId.toString());
    let cnrsMap = {};
    if (props.cnrList) {
        props.cnrList.map((cnr: CnrDto) => {
            cnrsMap[cnr.objectId] = cnr;
        });
    }

    return (
        <Dialog
            title={t("PSL_COPY:STATS_DIALOG_TITLE")}
            customStyleClassName={"scrollableYDialog"}
            open={true}
            actions={
                [
                    props.basicMarketCnr && totalCount > 0 ?
                        <Button
                            key={"submit"}
                            icon={"checkmark"}
                            label={t("GLOBAL:CONFIRM")}
                            onClick={props.onConfirm}
                        /> : <></>,
                    <Button
                        key={"cancel"}
                        icon={"ban"}
                        label={t("GLOBAL:CANCEL")}
                        onClick={props.onCancel}
                    />
                ]
            }
        >
            {
                totalCount > 0 ?
                    <>
                        <p><b>{totalCount}</b>{' ' + t("PSL_COPY:SOURCE_CONTEXT_COUNT") + ' '}<b>{pslCopyParams.sourceTypefamily + ' - ' + pslCopyParams.sourceModelyear}</b></p>

                        <p>{t("PSL_COPY:STATS_DIALOG_TEXT")}</p>
                        <Table celled={true} structured={true}>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>{t("PSL_COPY:PSL_MARKET")}</Table.HeaderCell>
                                    <Table.HeaderCell>{t("PSL_COPY:OPTIONS_COUNT")}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {props.basicMarketCnr &&
                                    <Table.Row>
                                        <Table.Cell>
                                            <Label ribbon={true}>
                                                {props.basicMarketCnr.name}
                                            </Label>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {props.stats[props.basicMarketCnr.objectId]}
                                        </Table.Cell>
                                    </Table.Row>
                                }
                                {
                                    specificMarketsKeys.length > 0 &&
                                    specificMarketsKeys.map((key, index) => {
                                        return (
                                            <Table.Row key={'row-' + index}>
                                                <Table.Cell>
                                                    <Label ribbon={true} color={"black"}>
                                                        {cnrsMap[key] ? cnrsMap[key].name : "<objectId:" + key + ">"}
                                                    </Label>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {props.stats[key] + ' ' + t("PSL_COPY:SPECIFIC_TYPE")}
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })
                                }
                            </Table.Body>
                        </Table>
                    </>
                    :
                    <p>{t("PSL_COPY:EMPTY_SOURCE_CONTEXT", pslCopyParams)}</p>
            }
        </Dialog>
    );
};

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    basicMarketCnr: selectBasicMarketCnr(state),
    cnrList: selectUserCnrs(state)
});

export default compose<React.StatelessComponent<IOwnProps>>
    (connect<IMapStateToProps>(mapStateToProps))
    (PSLCopyStatsDialog);



// WEBPACK FOOTER //
// ./src/views/OptionsView/PSL/PSLCopyStatsDialog.tsx